module.exports = __webpack_public_path__ + "img/09_DSC7911.50d063a1.jpg";